import {
  ComponentType,
  ConnectionPositionPair,
  FlexibleConnectedPositionStrategy,
  GlobalPositionStrategy, OriginConnectionPosition,
  Overlay,
  OverlayConfig,
  OverlayConnectionPosition,
  OverlayContainer
} from '@angular/cdk/overlay';
import { ComponentPortal, TemplatePortal } from '@angular/cdk/portal';
import {
  ApplicationRef, ComponentFactoryResolver, ElementRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { forkJoin, Observable, Subject, Subscription } from 'rxjs';
import { AdDialogService } from './ad-dialog.service';
import {
  AdCautionParameter, AdMessageApi, CLOSEME, ComponentProps,
  ConfirmProps, IadMessageConfig,
  IComponentConfig, IConfirmProps, IInnerHTMLConfig, IPComponent,
  IPTemplate, ITemplateConfig, ITextConfig, OVERLAYREF, PanelComponentRef, PanelOverlayConfig, PanelTemplateRef, ProgressBarModalParm, ProgressRunProps, TemplateProps
} from './adMessageConfig';
import { AdCautionComponent } from './components/ad-caution.component';
import { AdConfirmComponent } from './components/ad-confirm.component';
import { AdDynamicMessage } from './components/ad-dynamicmessage.component';

import { omit } from '@internal/common-ui/common';
import { catchError, concatMap, map, take, tap } from 'rxjs/operators';
import { AdProgressbarComponent } from './components/ad-progressbar-modal.component';
import { getDefaultViewContainerRef } from './rootviewcontainer';
export type IAdDynamicDialogRef = DynamicDialogRef & {
  dispatchOkBtnDisable: (boolean) => void;
  getBodyComponent: () => any;
}

@Injectable({ providedIn: 'root' })
export class AdMessageService {
  baseZindex: number = 10000;
  _defaultViewContainer: ViewContainerRef;
  subject: any = {
    mainbuttonDisable: new Subject<boolean>(),
  };
  observables: any = {
    mainbuttonDisable$: this.subject.mainbuttonDisable.asObservable(),
  };
  get mainbuttonDisable$() {
    return this.observables.mainbuttonDisable$;
  }
  invokemainButtonDisable(val: boolean) {
    this.subject.mainbuttonDisable.next(val);
  }

  constructor(
    private dialogService: AdDialogService,
    public overlay: Overlay,
    private _overlayContainer: OverlayContainer,
    private _injector: Injector,
    private _appRef: ApplicationRef,
    private _factoryResolver: ComponentFactoryResolver,
  ) {
    this._defaultViewContainer = getDefaultViewContainerRef({
      appRef: this._appRef,
      factoryResolver: this._factoryResolver,
      injector: this._injector
    });
  }

  open(componnetConfig: IPComponent): IAdDynamicDialogRef;
  open(textConfig: ITextConfig): IAdDynamicDialogRef;
  open(htmlConfig: IInnerHTMLConfig): IAdDynamicDialogRef;
  open(templateConfig: IPTemplate): IAdDynamicDialogRef;
  open(adconfig?: IadMessageConfig, config?: DynamicDialogConfig): IAdDynamicDialogRef;
  open(legacyTemplateConfig: ITemplateConfig): IAdDynamicDialogRef;

  open(adconfig?: IPComponent | IComponentConfig | IPTemplate | ITemplateConfig | ITextConfig | IInnerHTMLConfig | IadMessageConfig, config?: DynamicDialogConfig) {
    if (!adconfig) {
      adconfig = {};
    }
    adconfig = Object.assign(
      {
        l2Text: 'Are you sure?',
        mainPathText: 'Yes',
        secondaryPathText: 'No',
        isShowMessageAgainVisible: true,
        isSecondaryButtonHidden: false,
        showHeader: true,
        showOriginalHeader: false,
        titleText: 'Warning',
        closable: false,
      },
      { ...adconfig }
    );
    if (!config) {
      config = new DynamicDialogConfig();
    }
    config = Object.assign(
      {
        closeOnEscape: false,
      },

      { ...config },
      { baseZIndex: adconfig.baseZIndex },
      { showHeader: false },
    );
    if (adconfig.headerTemplateContext != null &&
      Object.keys(adconfig.headerTemplateContext).length > 0 &&
      !('$implicit' in adconfig.headerTemplateContext)
    ) {
      adconfig.headerTemplateContext['$implicit'] = adconfig.headerTemplateContext;
    }
    config.data = adconfig;
    if (adconfig.closeOnEscape != null) {
      config.closeOnEscape = adconfig.closeOnEscape;
    }
    if (adconfig.closeOnEscape != null) {
      config.closeOnEscape = adconfig.closeOnEscape;
    }
    if (adconfig.showOriginalHeader) {
      config.showHeader = adconfig.showOriginalHeader;
    }
    return this.dialogService.open(AdDynamicMessage, config);
  }

  confirmBeforeProcess(param: IConfirmProps) {
    const { title, message, onOk: originalOk, onCancel: originalCancel, okText = 'Confirm', cancelText = 'Cancel', ...rest } = param;
    return this.open(
      {
        titleText: title,
        l2Text: message,
        onOk: !!originalOk ? ({ closeMe }) => { originalOk(); closeMe(); } : undefined,
        onCancel: !!originalCancel ? ({ closeMe }) => { originalCancel(); closeMe(); } : undefined,
        mainPathText: okText,
        secondaryPathText: cancelText,
        isShowMessageAgainVisible: false,
        ...rest
      }
    )
  }



  caution(param: AdCautionParameter) {
    const inputs: AdCautionParameter = {
      ...omit(param, ['confirmCallback', 'cancelCallback']),
      confirmCallback: () => {
        param.confirmCallback?.();
        api.closeAdMessage();
      },
      cancelCallback: () => {
        param.cancelCallback?.();
        api.closeAdMessage();
      },
    };
    let { api } = this.openPanelComponent(
      AdCautionComponent,
      null,
      null,
      null,
      { zIndex: this.baseZindex++ },
      inputs
    );
  }
  confirm(message?: string,
    dialogTitle?: string,
    confirm?: () => void,
    cancel?: () => void,
    isCancelHidden?: boolean,
    confirmLabel?: string,
    cancelLabel?: string): void;
  confirm(props?: ConfirmProps): void;
  confirm(
    props?: string | ConfirmProps,
    dialogTitle?: string,
    confirm?: () => void,
    cancel?: () => void,
    isCancelHidden?: boolean,
    confirmLabel?: string,
    cancelLabel?: string
  );
  confirm(
    props: ConfirmProps | string,
    dialogTitle?: string,
    confirm?: () => void,
    cancel?: () => void,
    isCancelHidden?: boolean,
    confirmLabel?: string,
    cancelLabel?: string,
    closable?: boolean) {
    let message = '';
    let details: string[] = [];
    let dialogClass = null;
    if (typeof props === 'object' && props != null) {
      message = props.message;
      confirm = props.confirm;
      cancel = props.cancel;
      isCancelHidden = props.isCancelHidden;
      confirmLabel = props.confirmLabel;
      cancelLabel = props.cancelLabel;
      dialogTitle = props.dialogTitle;
      details = props.details;
      closable = props.closable;
      dialogClass = props.dialogClass;
    } else {
      message = props as string;
    }
    let inputs = {
      confirm: () => {
        confirm?.();
        overlayRef.detach();
      },
      cancel: () => {
        cancel?.();
        overlayRef.detach();
      },
      closeMe: () => {
        overlayRef.detach();
      },
      warningIcon: 'fa fa-exclamation',
      message: message || 'Are you sure?',
      details: details || null,
      //cancelIcon: 'fa fa-times',
      cancelText: cancelLabel || 'No',
      isCancelHidden: isCancelHidden,
      //confirmIcon: 'fa fa-check',
      confirmText: confirmLabel || 'Yes',
      title: dialogTitle || 'Confirmation',
      closable,
      dialogClass,
    };
    let { overlayRef } = this.openPanelComponent(
      AdConfirmComponent,
      null,
      null,
      null,
      { zIndex: this.baseZindex++ },
      inputs
    );
  }

  progress(param: ProgressBarModalParm) {
    const inputs = {
      title: param.title,
      config: omit(param, ['title', 'closable']),
      closable: param.closable,
    };
    let { api, componentRef } = this.openPanelComponent(
      AdProgressbarComponent,
      null,
      null,
      null,
      { zIndex: this.baseZindex++ },
      inputs
    );
    const component: AdProgressbarComponent =
      componentRef.instance as AdProgressbarComponent;
    return {
      updateProgress: (progress: number) => component.updateValue(progress),
      completOneTask: () => component.completOneTask(),
      closeProgress: () => api.closeAdMessage(),
      api,
    };
  }

  assignAsyncTasks(asyncTasks: Observable<any>[] | Observable<any>[][], totalQueueNumber: number = 5): Observable<any>[] {
    let queue: Observable<any[]>[] = new Array(totalQueueNumber).fill(null);
    for (let i = 0; i < asyncTasks.length; i++) {
      const eachItem = asyncTasks[i];
      let transferedAsyncTask: Observable<any[]> = null;
      if (Array.isArray(eachItem)) {
        for (let j = 0; j < eachItem.length; j++) {
          const innerAsync = eachItem[j].pipe(
            take(1),
            map(it => [it])
          );
          if (transferedAsyncTask == null) {
            transferedAsyncTask = innerAsync;
          } else {
            transferedAsyncTask = transferedAsyncTask.pipe(
              concatMap(pre => innerAsync.pipe(map(it => [...pre, ...it])))
            );
          }
        }
      } else {
        transferedAsyncTask = eachItem.pipe(
          take(1),
          map(it => [it])
        );
      }
      const queueIndex = i % totalQueueNumber;
      let queueItem = queue[queueIndex];
      if (queueItem == null) {
        queue[queueIndex] = transferedAsyncTask;
      } else {
        queue[queueIndex] = queueItem.pipe(
          concatMap(pre => transferedAsyncTask.pipe(map(it => [...pre, ...it])))
        );
      }

    }

    return queue.filter(it => it != null);

  }

  runWithProgress(runParam: ProgressRunProps) {
    let { asyncParams, onSuccess, onFailed, skipProgressManagement = false, totalAsyncCount, ...param } = runParam;
    const total = totalAsyncCount > 0 ? totalAsyncCount : asyncParams.length;
    param = { ...param, mode: 'reactMode', totalTasks: total };
    const ref = this.progress(param);
    const { completOneTask } = ref;
    forkJoin(asyncParams.map(it => {
      return it
        .pipe(
          tap(() => !skipProgressManagement ? completOneTask() : null),
          map(item => item),
          take(1)
        );
    }))
      .pipe(
        catchError(err => {
          onFailed?.(err);
          throw err;
        })
      ).subscribe(result => {
        onSuccess?.(result);
      });
    return ref;
  }

  _applyZindexToCDKOverlayContainer(zIndex: number) {
    if (zIndex == null) {
      return null;
    }
    const containerElement: HTMLElement =
      this._overlayContainer.getContainerElement();
    const originalZindex = Number.isNaN(parseInt(containerElement.style.zIndex))
      ? 1000
      : parseInt(containerElement.style.zIndex);
    containerElement.style.zIndex = `${zIndex}`;
    return () => {
      containerElement.style.zIndex = `${originalZindex}`;
    };
  }

  /**
   * Use CDK Overlay to display component relative to depended HTML Element or global
   * If you need to access to overlayref or close opened dialog inject this @Optional()private adMessageApi:AdMessageApi
   * @param template: TemplateRef<any> template to display
   * @param viewContainerRef viewContainer where the template will be created in.
   * @param context  context will be passed to the template.
   * @param dependedComponent html element where the component will relative to, if null, it will be modal mode
   * @param hideOnDropbackClick add click to close feature
   * @param config Angular CDK OverlayConfig, for advanced usage.
   */
  openPanelTemplate(
    template: TemplateRef<any>,
    viewContainerRef?: ViewContainerRef,
    context?: any,
    dependedElement?: ElementRef | HTMLElement,
    hideOnDropbackClick?: boolean,
    config?: PanelOverlayConfig,
    callbackBeforeClose?: () => void
  ): PanelTemplateRef;
  openPanelTemplate(param: TemplateProps): PanelTemplateRef;

  openPanelTemplate(param: TemplateProps | TemplateRef<any>,
    viewContainerRef?: ViewContainerRef,
    context?: any,
    dependedElement?: ElementRef | HTMLElement,
    hideOnDropbackClick?: boolean,
    config?: PanelOverlayConfig,
    callbackBeforeClose?: () => void) {
    let template: TemplateRef<any> = null;
    if ('template' in param) {
      template = param.template;
      viewContainerRef = param.viewContainerRef;
      context = param.context;
      dependedElement = param.dependedElement;
      hideOnDropbackClick = param.hideOnDropbackClick;
      config = param.config;
      callbackBeforeClose = param.callbackBeforeClose;
    } else {
      template = param;
    }
    let overlayConfig = this._getDefaultOverlayConfig(
      dependedElement != null
        ? dependedElement instanceof ElementRef
          ? dependedElement
          : new ElementRef(dependedElement)
        : null
    );
    if (!dependedElement) {
      overlayConfig.backdropClass = 'cdk-overlay-dark-backdrop';
    }
    if (config != null) {
      Object.assign(overlayConfig, config);
    }

    let overlayRef = this.overlay.create(overlayConfig);
    overlayRef.overlayElement.classList.add('a-message-panel-overlay');
    const recoverZindex: Function = this._applyZindexToCDKOverlayContainer(
      config?.zIndex
    );

    let dropBackListener: Subscription;
    let detachListener: Subscription;
    const closeOverlay = () => {
      if (dropBackListener != null) {
        dropBackListener.unsubscribe();
        dropBackListener = null;
      }
      overlayRef.detach();
      callbackBeforeClose?.();
    };
    if (hideOnDropbackClick == true) {
      dropBackListener = overlayRef.backdropClick().subscribe(() => {
        closeOverlay?.();
      });
    }
    if (recoverZindex) {
      detachListener = overlayRef.detachments().subscribe(() => {
        recoverZindex?.();
        if (detachListener != null) {
          detachListener.unsubscribe();
          detachListener = null;
        }
      });
    }
    const api: AdMessageApi = {
      overlayRef: overlayRef,
      closeAdMessage: closeOverlay,
    };
    if (!context) {
      context = {};
    }
    if (!('$implicit' in context)) {
      context = { $implicit: context };
    }
    let childContext = { ...context, api };
    let embeddedViewRef = overlayRef.attach(
      new TemplatePortal(template, viewContainerRef || this._defaultViewContainer, childContext)
    );

    return { overlayRef, embeddedViewRef, api };
  }

  /**
   * Use CDK Overlay to display component relative to depended HTML Element or global
   * If you need to access to overlayref or close opened dialog inject this @Optional()private adMessageApi:AdMessageApi
   * @param component: ComponentType<PortalComponentType<D>>|ComponentType<any> Component to display
   * @param data params injected into component
   * @param dependedComponent html element where the component will relative to, if null, it will be modal mode
   * @param hideOnDropbackClick add click to close feature
   * @param config Angular CDK OverlayConfig, for advanced usage
   * @param inputs inputs of Components, e.g. @Input in Component, Object.assign will be used to auto assign
   */
  openPanelComponent(
    component: ComponentType<any>,
    data?: { callbackBeforeClose?: () => void;[key: string]: any } | null,
    dependedComponent?: ElementRef | HTMLElement,
    hideOnDropbackClick?: boolean,
    config?: PanelOverlayConfig,
    inputs?: any,
    injector?: Injector,
    skipAnimation?: boolean,
    skipOverlayStyle?: boolean,
  ): PanelComponentRef;
  openPanelComponent(props: ComponentProps): PanelComponentRef;

  openPanelComponent(
    props: ComponentType<any> | ComponentProps,
    data?: { callbackBeforeClose?: () => void;[key: string]: any } | null,
    dependedComponent?: ElementRef | HTMLElement,
    hideOnDropbackClick?: boolean,
    config?: PanelOverlayConfig,
    inputs?: any,
    injector?: Injector,
    skipAnimation?: boolean,
    skipOverlayStyle?: boolean,
  ) {
    let component: ComponentType<any>;
    if ('component' in props) {
      component = props.component;
      data = props.data;
      dependedComponent = props.dependedComponent;
      hideOnDropbackClick = props.hideOnDropbackClick;
      config = props.config;
      inputs = props.inputs;
      injector = props.injector || this._injector;
      skipAnimation = props.skipAnimation;
      skipOverlayStyle = props.skipOverlayStyle;
    } else {
      component = props;
    }
    injector = injector || this._injector;
    let overlayConfig = this._getDefaultOverlayConfig(
      dependedComponent != null
        ? dependedComponent instanceof ElementRef
          ? dependedComponent
          : new ElementRef(dependedComponent)
        : null
    );
    if (!dependedComponent) {
      overlayConfig.backdropClass = 'cdk-overlay-dark-backdrop';
    }
    if (config != null) {
      Object.assign(overlayConfig, config);
    }

    let overlayRef = this.overlay.create(overlayConfig);
    if (!skipOverlayStyle) {
      overlayRef.overlayElement.classList.add('a-message-panel-overlay');
    }
    const recoverZindex: Function = this._applyZindexToCDKOverlayContainer(
      config?.zIndex
    );

    let dropBackListener: Subscription;
    let detachListener: Subscription;
    const closeOverlay = () => {
      if (dropBackListener != null) {
        dropBackListener.unsubscribe();
        dropBackListener = null;
      }
      overlayRef.detach();
    };
    if (hideOnDropbackClick == true) {
      dropBackListener = overlayRef.backdropClick().subscribe(() => {
        data?.callbackBeforeClose?.();
        closeOverlay?.();
      });
    }
    if (recoverZindex) {
      detachListener = overlayRef.detachments().subscribe(() => {
        recoverZindex?.();
        if (detachListener != null) {
          detachListener.unsubscribe();
          detachListener = null;
        }
      });
    }
    const api: AdMessageApi = {
      overlayRef: overlayRef,
      closeAdMessage: closeOverlay,
    };
    let childInjector: Injector = Injector.create({
      providers: [{ provide: AdMessageApi, useValue: api }],
      parent: injector,
    });
    let componentRef = overlayRef.attach(
      new ComponentPortal(component, null, childInjector)
    );
    componentRef.instance.data = {
      ...data,
      overlayRef,
      closeOverlay: () => {
        closeOverlay();
      },
    };
    if (inputs && Object.keys(inputs).length > 0) {
      Object.assign(componentRef.instance, inputs);
    }
    componentRef.instance[OVERLAYREF] = overlayRef;
    componentRef.instance[CLOSEME] = () => closeOverlay();
    if (!skipAnimation) {
      this._applyAnimation(((componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement).parentElement);
    }
    return { overlayRef, componentRef, api };
  }

  private _applyAnimation(overlayPanel: HTMLElement) {
    overlayPanel.animate([
      { opacity: 0, transform: 'scale(0.7)' },
      { opacity: 1, transform: 'none' },
    ], {
      duration: 300,
      easing: 'cubic-bezier(0, 0, 0.2, 1)'
    });
  }

  private _getDefaultOverlayConfig(
    dependedComponent: ElementRef | null | undefined
  ): OverlayConfig {
    let result: OverlayConfig = {
      positionStrategy: this._getPositionStrategy(dependedComponent),
      hasBackdrop: true,
      scrollStrategy: this.overlay.scrollStrategies.block(),
      backdropClass: 'cdk-overlay-transparent-backdrop',
    };
    return result;
  }

  getPositionStrategy(
    dependedComponent: ElementRef,
    pairs: {
      original: OriginConnectionPosition;
      overlay: OverlayConnectionPosition;
      offsetX?: number;
      offsetY?: number;
    }[]
  ) {
    return this.overlay
      .position()
      .flexibleConnectedTo(dependedComponent)
      .withPositions([
        ...pairs.map(
          (it) =>
            new ConnectionPositionPair(
              it.original,
              it.overlay,
              it.offsetX,
              it.offsetY
            )
        ),
      ])
      .withPush(false);
  }

  private _getPositionStrategy(
    dependedComponent: ElementRef | null | undefined
  ): GlobalPositionStrategy | FlexibleConnectedPositionStrategy {
    if (dependedComponent != null) {
      return this.overlay
        .position()
        .flexibleConnectedTo(dependedComponent)
        .withPositions([
          { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 0, },
          { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: 0 },
        ])
        .withPush(false);
    } else {
      return this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically();
    }
  }

  //#region Deprecated functions

  /**
   *
   * @deprecated Please use open(componnetConfig: IComponentConfig) instead
   * @returns DynamicDialogRef
   */
  openComponent(componnetConfig: IComponentConfig) {
    return this.open(componnetConfig);
  }

  /**
   *
   * @deprecated Please use open(textConfig: ITextConfig) instead
   * @returns DynamicDialogRef
   */
  openText(textConfig: ITextConfig) {
    return this.open(textConfig);
  }

  /**
   *
   * @deprecated Please use open(htmlConfig: IInnerHTMLConfig) instead
   * @returns DynamicDialogRef
   */
  openHTML(htmlConfig: IInnerHTMLConfig) {
    return this.open(htmlConfig);
  }

  /**
   *
   * @deprecated Please use open(templateConfig: ITemplateConfig) instead
   * @returns DynamicDialogRef
   */
  openTemplate(templateConfig: ITemplateConfig) {
    return this.open(templateConfig);
  }

  /**
   *
   * @deprecated Please use confirm(props: ConfirmProps) instead
  */
  areYouSureToDoSomething(props: ConfirmProps): void;
  /**
  *
  * @deprecated Please use confirm(props: ConfirmProps) instead
  */
  areYouSureToDoSomething(
    content: string,
    acceptCallback: () => void,
    rejectCallback?: () => void,
    isRejectVisible?: boolean,
    mainPathText?: string,
    secondaryPathText?: string,
    titleText?: string,
    details?: string[] | null,
    closable?: boolean,
  ): void;

  areYouSureToDoSomething(
    props: ConfirmProps | string,
    acceptCallback?: () => void,
    rejectCallback?: () => void,
    isRejectVisible?: boolean,
    mainPathText?: string,
    secondaryPathText?: string,
    titleText?: string,
    details?: string[] | null,
    closable?: boolean,
  ): void {
    if (typeof props === 'string') {
      let confirmProps: ConfirmProps = {
        message: props,
        confirm: acceptCallback,
        cancel: rejectCallback,
        isCancelHidden: isRejectVisible === false ||
          (!isRejectVisible && rejectCallback == null),
        confirmLabel: mainPathText,
        cancelLabel: secondaryPathText,
        details,
        closable,
        dialogTitle: titleText,
      }
      this.confirm(confirmProps);
    } else {
      this.confirm(props);
    }
  }
  //#endregion
}

